import { Navigate, Route } from 'react-router-dom';
import { OperatorLayout } from '../../layouts/OperatorLayout';
import { OperatorFlowGate } from '../../layouts/OperatorFlowGate';
import { OPERATOR_FLOW } from '../../features/operator/operatorConstants';
import { OperatorNotFound } from './components/OperatorNotFound';
import { OperatorHome } from './pages/OperatorHome/OperatorHome';
import { StockLookup } from './pages/Lookup/StockLookup';
import { ReceivingQueue } from './pages/Receiving/ReceivingQueue';
import { ReceivingCount } from './pages/Receiving/ReceivingCount';
import { PutawayTask } from './pages/Putaway/PutawayTask';
import { PickingQueue } from './pages/Picking/PickingQueue';
import { PickingWalk } from './pages/Picking/PickingWalk';
import { PickingRoute } from './pages/Picking/PickingRoute';
import { PackingQueue } from './pages/Packing/PackingQueue';
import { PackingOrder } from './pages/Packing/PackingOrder';
import { DispatchStation } from './pages/Dispatch/DispatchStation';
import { KitStation } from './pages/Kits/KitStation';
import { KitDetail } from './pages/Kits/KitDetail';

/**
 * The warehouse operator's workspace. Inicio sits at `/dashboard` because
 * that is where every login lands; each flow only opens in a warehouse that
 * allows it.
 */
export const operatorRoutes = (
  <Route element={<OperatorLayout />}>
    <Route path="/home" element={<Navigate to="/dashboard" replace />} />
    <Route path="/dashboard" element={<OperatorHome />} />

    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.RECEIVING} />}>
      <Route path="/receiving" element={<ReceivingQueue />} />
      <Route path="/receiving/:receiptId" element={<ReceivingCount />} />
    </Route>
    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.PUTAWAY} />}>
      <Route path="/putaway" element={<PutawayTask />} />
    </Route>
    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.PICKING} />}>
      <Route path="/picking" element={<PickingQueue />} />
      <Route path="/picking/route" element={<PickingRoute />} />
      {/* Both ways live side by side: an order alone line by line, a batch by route. */}
      <Route path="/picking/:orderId" element={<PickingWalk />} />
    </Route>
    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.PACKING} />}>
      <Route path="/packing" element={<PackingQueue />} />
      <Route path="/packing/:orderId" element={<PackingOrder />} />
    </Route>
    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.DISPATCH} />}>
      <Route path="/dispatch" element={<DispatchStation />} />
    </Route>
    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.KITS} />}>
      <Route path="/kits" element={<KitStation />} />
      <Route path="/kits/:kitId" element={<KitDetail />} />
    </Route>
    <Route element={<OperatorFlowGate flow={OPERATOR_FLOW.STOCK} />}>
      <Route path="/lookup" element={<StockLookup />} />
    </Route>

    <Route path="*" element={<OperatorNotFound />} />
  </Route>
);
